import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationCreatedTemplates = [
  {
    id: '-115001',
    language: Language.EN,
    subject: 'A new exceptional charge or service has been added to your lease',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: new {{getLeaseVariousType lvo language}} on the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Details:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Amount: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Comment: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Start date: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duration: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Frequency: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        {{#if (hasSeparateInvoice lvo)}}
        <p>This {{getLeaseVariousType lvo language}} will be subject to a separate {{getInvoiceOrPaymentRequest lease}}.</p>
        {{else}}
        <p>This {{getLeaseVariousType lvo language}} will be subject to a specific line on your periodical {{getInvoiceOrPaymentRequest lease}}.</p>
        {{/if}}
        <p></p>
        <p>This {{getLeaseVariousType lvo language}} should be considered separate from any charges provisions or fixed charges foreseen in your lease contract.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-115003',
    language: Language.NL,
    subject: 'Een nieuwe uitzonderlijke last of dienst werd aan je huurcontract toegevoegd',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: nieuwe {{getLeaseVariousType lvo language}} op uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Details:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Bedrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Opmerking: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Begindatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duur: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Betaling frequentie: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        {{#if (hasSeparateInvoice lvo)}}
        <p>Deze {{getLeaseVariousType lvo language}} zal op een aparte {{getInvoiceOrPaymentRequest lease}} worden gebracht.</p>
        {{else}}
        <p>Voor deze {{getLeaseVariousType lvo language}} zal een specifieke rubriek op uw periodische {{getInvoiceOrPaymentRequest lease}} worden vermeld.</p>
        {{/if}}
        <p></p>
        <p>Deze {{getLeaseVariousType lvo language}} moet los worden gezien van eventuele lasten provisies of vaste lasten in uw huurcontract.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-115002',
    language: Language.FR,
    subject: 'Une nouvelle charge ou service exceptionnel a été ajouté à votre bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        {{#if (leaseVariousOperationIsService lvo)}}
        <p>Concerne: nouveau service sur le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{else}}
        <p>Concerne: nouvelle charge exceptionnelle sur le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{/if}}
        <p></p>
        <p>Détails:</p>
        <ul>
        <li>Libellé: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Montant: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Commentaire: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Date de début: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Durée: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Fréquence: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        {{#if (leaseVariousOperationIsService lvo)}}
        {{#if (hasSeparateInvoice lvo)}}
        <p>Ce service fera l'objet d'une {{getInvoiceOrPaymentRequest lease}} séparée.</p>
        {{else}}
        <p>Ce service fera l'objet d'une ligne spécifique sur votre {{getInvoiceOrPaymentRequest lease}} périodique.</p>
        {{/if}}
        <p></p>
        <p>Ce service doit être considéré séparément de toute provision de charges ou charges fixes prévues dans votre contrat de bail.</p>
        {{else}}
        {{#if (hasSeparateInvoice lvo)}}
        <p>Cette charge exceptionnelle fera l'objet d'une {{getInvoiceOrPaymentRequest lease}} séparée.</p>
        {{else}}
        <p>Cette charge exceptionnelle fera l'objet d'une ligne spécifique sur votre {{getInvoiceOrPaymentRequest lease}} périodique.</p>
        {{/if}}
        <p></p>
        <p>Cette charge exceptionnelle doit être considérée séparément de toute provision de charges ou charges fixes prévues dans votre contrat de bail.</p>
        {{/if}}
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-115004',
    language: Language.DE,
    subject: 'Eine neue außergewöhnliche Gebühr oder Dienstleistung wurde zu Ihrem Mietvertrag hinzugefügt',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: neue {{getLeaseVariousType lvo language}} für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Details:</p>
        <ul>
        <li>Bezeichnung: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Betrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Kommentar: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Startdatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Dauer: <strong>{{lvoDuration lvo language}}</strong></li>
        <li>Häufigkeit: <strong>{{getLeaseVariousOperationFrequency lvo language}}</strong></li>
        </ul>
        <p></p>
        {{#if (hasSeparateInvoice lvo)}}
        <p>Diese {{getLeaseVariousType lvo language}} wird auf einer separaten {{getInvoiceOrPaymentRequest lease}} ausgewiesen.</p>
        {{else}}
        <p>Diese {{getLeaseVariousType lvo language}} wird als spezifische Position auf Ihrer periodischen {{getInvoiceOrPaymentRequest lease}} aufgeführt.</p>
        {{/if}}
        <p></p>
        <p>Diese {{getLeaseVariousType lvo language}} sollte getrennt von allen Nebenkostenvorauszahlungen oder festen Nebenkosten in Ihrem Mietvertrag betrachtet werden.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
